import * as Tooltip from "@radix-ui/react-tooltip"
import type { FieldTooltipProps } from "@site-types/sendMail"

/**
 * Wraps a form field in a Radix Tooltip that shows an error message.
 * Uses Radix Portal so the tooltip content is positioned at document root —
 * avoids the viewport overflow issue of the old `position: absolute; top: -35px` approach.
 */
export const FieldTooltip = ({ message, open, children }: FieldTooltipProps) => (
  <Tooltip.Provider delayDuration={0}>
    <Tooltip.Root open={open}>
      <Tooltip.Trigger asChild>
        <span style={{ display: "block", width: "100%" }}>{children}</span>
      </Tooltip.Trigger>

      <Tooltip.Portal>
        <Tooltip.Content
          className="relative z-[200] max-w-[260px] overflow-visible break-words rounded-md bg-[#555] px-[15px] py-[5px] text-left text-[10px] text-white leading-[1.4] [animation:fade-in_150ms_ease] after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:border-[#555_transparent_transparent_transparent] after:border-[5px] after:border-solid after:content-['']"
          side="top"
          sideOffset={12}
          align="end"
          avoidCollisions
          collisionPadding={8}
        >
          {message}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>
)
